export default __webpack_public_path__ + "static/media/styled-components-logo-light-mode.44706a78.png";